<template>
  <modal
    id="modalPeriodoContabIL"
    :exibir="exibir"
    :titulo="titulo"
    :campos="$refs"
    tamanho="xl"
    @fechar="fecharModal"
  >
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4 col-xl-2 alinharValidacao">
        <input-text
          required
          ref="descricao"
          v-model="form.descricao"
          label="Descrição"
        />
      </b-col>

      <b-col class="col-12 col-md-4 alinharValidacao">
        <input-date-only-btn
          ref="dataInicioSegmentacao"
          label="Data início"
          required
          v-model="form.dataInicio"
        />
      </b-col>

      <b-col class="col-12 col-md-4 alinharValidacao">
        <input-date-only-btn
          ref="dataFimSegmentacao"
          label="Data fim"
          required
          v-model="form.dataFim"
        />
      </b-col>

      <b-col class="col-12 col-md-2 alinharValidacao">
        <input-select-search
          ref="statusAbertura"
          :label="'Status'"
          :options="opcoes.statusAbertura"
          v-model="form.statusAbertura"
          required
          :loading="loadingStatusAbertura"
        />
      </b-col>

      <b-col class="col-12 col-md-2 mt-4">
        <input-checkbox
          ref="lancamentoNota"
          v-model="form.lancamentoNota"
          label="Nota"
        />
      </b-col>

      <b-col class="col-12 col-md-2 mt-4">
        <input-checkbox
          ref="lancamentoFrequencia"
          v-model="form.lancamentoFrequencia"
          label="Frequência"
        />
      </b-col>

      <b-col class="col-12 col-md-2 mt-4">
        <input-checkbox
          ref="lancamentoRecuperacao"
          v-model="form.lancamentoRecuperacao"
          label="Avaliação Final"
          :disabled="!avaliacaoFinal"
        />
      </b-col>
      <b-col class="col-12 col-md-3 mt-4">
        <input-checkbox
          ref="LancamentoRecuperacaoSegmentacao"
          v-model="form.lancamentoRecuperacaoSegmentacao"
          label="Recuperação segmentação"
        />
      </b-col>
    </b-row>
    <hr />
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.CANCELAR') }}
        </b-button>
        <b-button variant="primary" @click="adicionar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

//Model
import { Segmentacao } from '@/common/models';

// Service:
// import PeriodoContabilService from '@/common/services/periodo-contabil/periodo-contabil.service';
// import PeriodoContabilSaldoService from '@/common/services/periodo-contabil-saldo/periodo-contabil-saldo.service';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import SegmentacaoService from '@/common/services/anoLetivo/segmentacao.service';

// Components:
import Modal from '@/components/modal/Modal.vue';
import {
  InputText,
  InputDateOnlyBtn,
  InputCheckbox,
  InputSelectSearch,
} from '@/components/inputs';

export default {
  props: {
    exibir: { type: Boolean, default: false },
    dados: { type: Object, default: Object },
    anoLetivoId: { type: String, default: String },
    segmentacoes: { type: Array, default: Array },
    editarSegmentacao: { type: Object, default: Object },
    // Quando o período está com avaliação final desabilitada (avaliacaoFinal=false),
    // este checkbox não pode ser marcado pelo usuário.
    avaliacaoFinal: { type: Boolean, default: false },
  },
  components: {
    Modal,
    InputText,
    InputSelectSearch,
    InputDateOnlyBtn,
    InputCheckbox,
  },
  mounted() {
    this.listarStatusAbertura();
  },

  computed: {
    titulo() {
      return !this.form.id
        ? this.$t('GERAL.CADASTRAR')
        : this.$t('GERAL.EDITAR');
    },
  },
  data() {
    return {
      form: new Segmentacao({}),
      opcoes: {
        statusAbertura: [],
      },
      loadingStatusAbertura: false,
      index: null,
    };
  },
  methods: {
    // FUNÇÕES VALIDAÇÃO FORMULÁRIO:
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },

    listarStatusAbertura() {
      this.loadingStatusAbertura = true;
      EnumeradoresService.listar('status-abertura')
        .then(({ data }) => {
          data = data.map((row) => ({
            text: row.descricao,
            value: row.id,
          }));

          this.opcoes.statusAbertura = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingStatusAbertura = false;
        });
    },

    adicionar() {
      if (!this.validarFormulario()) return;
      this.form.statusAberturaDescricao = this.opcoes.statusAbertura.find(
        (item) => item.value === this.form.statusAbertura
      )?.text;
      if (this.anoLetivoId) {
        this.form.anoLetivoId = this.anoLetivoId;
        if (this.form.id) {
          this.editar();
        } else {
          this.salvar();
        }
      } else {
        if (this.index || this.index === 0) {
          this.$set(this.segmentacoes, this.form.index, this.form);
        } else {
          this.segmentacoes.push(this.form);
        }
        this.form = new Segmentacao({});
      }
      this.fecharModal();
    },

    salvar() {
      this.$store.dispatch(START_LOADING);
      SegmentacaoService.criar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Segmentação adicionada com sucesso')
          );
          this.$emit('atualizar');
          this.form = new Segmentacao({});
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    editar() {
      this.$store.dispatch(START_LOADING);
      SegmentacaoService.editar(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Segmentação editada com sucesso')
          );
          this.$emit('atualizar');
          this.form = new Segmentacao({});
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    fecharModal() {
      this.$emit('fechar');
    },
  },
  watch: {
    exibir: function (val) {
      if (val) {
        this.form = new Segmentacao({});
        this.index = null;
        if (this.editarSegmentacao) {
          this.form = this.editarSegmentacao;
          this.index = this.editarSegmentacao.index;
        }
        // Se o período não habilita avaliação final, garante que o checkbox inicie desmarcado.
        if (!this.avaliacaoFinal) {
          this.form.lancamentoRecuperacao = false;
        }
      }
    },
  },
};
</script>

<style>
@media (min-width: 992px) {
  .modal-xl {
    max-width: 1200px;
  }
}
</style>
